import { render, staticRenderFns } from "./TipsModal.vue?vue&type=template&id=d1560b28&"
import script from "./TipsModal.vue?vue&type=script&lang=js&"
export * from "./TipsModal.vue?vue&type=script&lang=js&"
import style0 from "./TipsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports